import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appFilterDropdownItem]'
})
export class KzDropdownItemDirective {

  public itemTemplate: TemplateRef<any>;

  @Input('appFilterDropdownItem') appFilterDropdownItem = false;
  @Input('appFilterDropdownItemSelected') appFilterDropdownItemSelected = false;

  constructor(
    private templateRef: TemplateRef<any>
    ) {
    this.itemTemplate = this.templateRef;
  }

}
